import { AvailableTemplate, Image, ImageExportDto } from '@ecosystem/export-api';
import { getContext } from './ExportUtils';
import { GetExportImagePowerPointParams, GetExportMultiImagePowerPointParams } from './Model';
import { ExportContext, PageName } from '@utils/pageConfig/Types';
import { ImageURLData } from '@ecosystem/export-utils';
import { SortDirection } from '@components/design/migrated/Table/Sorting/types';
import { startCase } from 'lodash';

export const getChartExportImage = (params: GetExportImagePowerPointParams): ImageExportDto => {
  const exportContext: ExportContext = {
    appliedCountry: params.appliedCountry,
    appliedPg: params.appliedPg,
    timePeriod: params.timePeriod,
    comparisonTimePeriod: params.comparisonTimePeriod,
    periodType: params.periodType,
    showPerformanceWithin: params.showPerformanceWithin,
    appliedFiltersText: params.appliedFiltersText,
    pageName: params.pageName,
    pageView: params.pageView,
    selectedKpi: params.selectedKpi.label,
    segmentBy: params.segmentBy,
    pagesConfig: params.pagesConfig,
    loadedProductGroups: params.loadedProductGroups,
    loadedCountries: params.loadedCountries,
  };

  return {
    source: params.imageData,
    title: params.title,
    template: AvailableTemplate.Image,
    name: params.filename,
    context: getContext(exportContext),
  };
};

export const getMultiChartExportImage = (params: GetExportMultiImagePowerPointParams): ImageExportDto => {
  const {
    sortedBy,
    pageName,
    appliedCountry,
    appliedPg,
    timePeriod,
    comparisonTimePeriod,
    periodType,
    showPerformanceWithin,
    appliedFiltersText,
    pageView,
    selectedKpi,
    segmentBy,
    loadedCountries,
    loadedProductGroups,
    pagesConfig,
  } = params;

  let sortDirectionText = '';
  if (sortedBy) {
    sortDirectionText = sortedBy.sortDirection === SortDirection.desc ? 'Descending' : 'Ascending';
  }

  const sortingLabel = sortedBy ? `${sortedBy.label} ${sortDirectionText}` : '';

  const sortedByContext = pageName === PageName.TRADING_ASSISTANT ? startCase(sortedBy) : sortingLabel;

  const exportContext: ExportContext = {
    appliedCountry,
    appliedPg,
    timePeriod,
    comparisonTimePeriod,
    periodType,
    showPerformanceWithin,
    appliedFiltersText,
    pageName,
    pageView,
    selectedKpi: selectedKpi.label === 'Select' ? '' : selectedKpi.label,
    sortedBy: sortedByContext,
    segmentBy,
    loadedCountries,
    loadedProductGroups,
    pagesConfig,
  };

  const images = params?.imageData?.map((image, index) => getBaseImage(image, params.chartSubTitles[index]));

  if (params.filename.includes('Compare Models')) {
    exportContext.pageName = PageName.RI_PRODUCT_COMPARE;
    return {
      source: images,
      title: params.chartTitles[0],
      layout: 'row',
      template: AvailableTemplate.Image,
      name: params.filename,
      context: getContext(exportContext),
    };
  }

  return {
    source: images,
    title: params.chartTitles[0],
    layout: 'column',
    template: AvailableTemplate.Image,
    name: params.filename,
    context: getContext(exportContext),
  };
};

const getBaseImage = (imageData: ImageURLData, subTitle: string): Image => {
  return {
    title: subTitle,
    dataUrl: imageData.dataUrl,
    height: imageData.height,
    width: imageData.width,
  };
};
